import React from 'react';
import styled from 'styled-components';
import Loader from '../Loader/Loader';

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
`;

function ScreenBlockerComponent(props) {
  const { message } = props;

  return message !== null && message.length > 0 ? (
    <Wrap>
      <Loader />
    </Wrap>
  ) : null;
}

export default ScreenBlockerComponent;
